module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cLJF5"))).then(() => parcelRequire('5erN3'));